import { ENDPOINTS } from '@app/Services/endpoints';
import {
	ApiRequest,
	convertStartDateToUTC,
	convertEndDateToUTC,
} from '@zeal/zeal-lib';
import { getLastRange } from './utils';
import { TAPINewsFeed } from '@modules/Dashboard/types';

export async function apiPaymentCardsAnalytics({ queryKey: [, filters] }: any) {
	const { dateFrom, dateTo, rangeType, branch } = filters;
	const { lastFrom, lastTo } = getLastRange({
		dateFrom: dateFrom,
		dateTo: dateTo,
	});

	const req = new ApiRequest(ENDPOINTS.dashboard.analytics.cards)
		.addHeader('Accept', 'application/json')
		.addQuery('type', rangeType)
		.addQuery('branch', branch);

	dateFrom && req.addQuery('from', convertStartDateToUTC(dateFrom));
	dateTo && req.addQuery('to', convertEndDateToUTC(dateTo));
	lastFrom && req.addQuery('last_from', convertStartDateToUTC(lastFrom));
	lastTo && req.addQuery('last_to', convertEndDateToUTC(lastTo));

	return req.GET();
}

export async function apiNewVsReturning({ queryKey: [, filters] }: any) {
	const { dateFrom, dateTo, rangeType, branch } = filters;
	const { lastFrom, lastTo } = getLastRange({
		dateFrom: dateFrom,
		dateTo: dateTo,
	});

	const req = new ApiRequest(ENDPOINTS.dashboard.analytics.newVsReturning)
		.addHeader('Accept', 'application/json')
		.addQuery('type', rangeType)
		.addQuery('branch', branch);

	dateFrom && req.addQuery('from', convertStartDateToUTC(dateFrom));
	dateTo && req.addQuery('to', convertEndDateToUTC(dateTo));
	lastFrom && req.addQuery('last_from', convertStartDateToUTC(lastFrom));
	lastTo && req.addQuery('last_to', convertEndDateToUTC(lastTo));

	return req.GET();
}

export async function apiTransactionsValue({ queryKey: [, filters] }: any) {
	const { dateFrom, dateTo, rangeType, branch } = filters;
	const { lastFrom, lastTo } = getLastRange({
		dateFrom: dateFrom,
		dateTo: dateTo,
	});

	const req = new ApiRequest(ENDPOINTS.dashboard.analytics.transactions)
		.addHeader('Accept', 'application/json')
		.addQuery('branch', branch);

	dateFrom && req.addQuery('from', convertStartDateToUTC(dateFrom));
	dateTo && req.addQuery('to', convertEndDateToUTC(dateTo));
	lastFrom && req.addQuery('last_from', convertStartDateToUTC(lastFrom));
	lastTo && req.addQuery('last_to', convertEndDateToUTC(lastTo));
	rangeType && req.addQuery('type', rangeType);
	return req.GET();
}

export async function apiNewsFeed({ queryKey: [, filters], pageParam }: any) {
	const { dateFrom, dateTo, branch } = filters;
	const req = new ApiRequest(ENDPOINTS.dashboard.analytics.newsFeed)
		.addHeader('Accept', 'application/json')
		.addQuery('page', pageParam || 1)
		.addQuery('branch', branch);

	dateFrom && req.addQuery('from', convertStartDateToUTC(dateFrom));
	dateTo && req.addQuery('to', convertEndDateToUTC(dateTo));

	return req
		.GET<ApiResponseWithPagination<TAPINewsFeed>>()
		.then(({ data, meta }) => ({
			data: data,
			lastPage: meta?.last_page,
			currentPage: meta?.current_page,
		}));
}
